import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import GuideLink from './GuideLink';

export default function Footer() {
  const { t } = useTranslation('footer');
  const { t: tGuide } = useTranslation('guide');
  const links = [
    ['/terms', t('labels.terms')], ['/privacy', t('labels.privacyPolicy')], ['/law', t('labels.legalNotice')],
    ['/policy', t('labels.corporateAndComplaintPolicies')], ['/company', t('labels.operatingCompany')],
  ] as const;
  return (
    <footer className="border-t border-gray-200 bg-gray-950 px-4 py-7 text-gray-200">
      <div className="mx-auto max-w-6xl text-center">
        <div className="mb-5 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm">
          <GuideLink className="hover:text-pink-300 hover:underline">{tGuide('links.footer')}</GuideLink>
          {links.map(([to, label]) => <Link key={to} to={to} className="hover:text-pink-300 hover:underline">{label}</Link>)}
        </div>
        <div className="mb-3 flex items-center justify-center gap-2 font-bold text-white"><span className="rounded bg-red-700 px-2 py-1 text-sm">R18+</span><span>{t('ageRestriction')}</span></div>
        <p className="text-sm">{t('operator')}</p>
        <p className="mt-2 text-xs text-gray-400">Copyright © {new Date().getFullYear()} Queen's Live All Rights Reserved.</p>
      </div>
    </footer>
  );
}
